<script setup lang="ts">
import type { BaseLink } from '~/types/base/baseLink';

export type LinkColorScheme =
  | 'custom'
  | 'light'
  | 'light-accent'
  | 'dark'
  | 'dark-accent';

interface Props {
  data: BaseLink;
  block?: boolean;
  colorScheme?: LinkColorScheme;
}

const props = withDefaults(defineProps<Props>(), {
  colorScheme: 'dark',
  block: false,
});

const isAnchor = computed(() => {
  return props.data.url?.startsWith('#');
});

const target = computed(() => {
  return props.data.targetBlank ? '_blank' : null;
});

const NuxtLinkLocale = resolveComponent('NuxtLinkLocale');
</script>

<template>
  <component
    :is="isAnchor ? 'a' : NuxtLinkLocale"
    :to="isAnchor ? undefined : data.url"
    :href="isAnchor ? data.url : undefined"
    :target
    :title="data.title"
    data-testid="base-link"
    class="flex items-center transition-colors focus-visible:rounded-md"
    :class="{
      'w-full': block,
      'w-max max-w-full': !block,

      'light-link': props.colorScheme === 'light',
      'light-accent-link': props.colorScheme === 'light-accent',
      'dark-link': props.colorScheme === 'dark',
      'dark-accent-link': props.colorScheme === 'dark-accent',
    }"
  >
    {{ data.title }}
  </component>
</template>
